import { UserDTO } from "../DTO/userDTO";
import { BasicRequest } from "./basicRequest";

export class CreateUserRequest extends BasicRequest{
    public user! : UserDTO;

    constructor(){
        super();
    }
}